import { createContext } from "@ecopages/radiant/context";
export const formContext = createContext(/* @__PURE__ */Symbol.for("rui-form-context"));